import { callApi } from "modules/core/api/services";
import { ApiResponse } from "modules/core/api/types";
import { Order } from "../../../types/interfaces/Order";

export const orders = () => callApi<ApiResponse<Order[]>>(`/v2/orders`);
